angular.module('logbook').directive('queryPanel', 
    ['$http', '$location', '$timeout', 'userService', 'reminderService', 
    function($http, $location, $timeout, userService, reminderService ) {
  return {
    redirect: 'E',

    scope: {
       query: '=',
       onResultFormatChanged: '=',
       onUpdate: '=',
       noteStyle: '=',
       resultFormat: '=',
       queryFormat: '=',
       validSorts: '=',
       selectedLog: '=',
       defaultSortKey: '=',
       users: '=?'
    },

	template: require('./query-panel.html'),

    link: function(scope, elem, attrs) {
       scope.selectedTagValues = [];
       scope.selectedTagValueObjects = [];
       
       scope.query = 
          $location.search()['query'] 
             ? JSON.parse($location.search()['query'])
             : {log: scope.selectedLog.id};
       
       if( scope.query.fromDate )
          try {
             scope.query.fromDate = new Date(scope.query.fromDate);
          } catch( err ) {}
       
       if( scope.query.thruDate )
          try {
             scope.query.thruDate = new Date(scope.query.thruDate);
          } catch( err ) {}
       
       if( !scope.query.tagValues )
          scope.query.tagValues = [];
       
       if( !scope.query.page )
          scope.query.page=0;
       if( !scope.query.size )
          scope.query.size=25;
       
       if( scope.query.sort )
       {
          scope.sort = scope.query.sort.map(function(sort) {
             return sort.replace(/,.*/, '');
          });
          scope.sortDir = scope.query.sort.map(function(sort) {
             return sort.replace(/.*,/, '');
          });
       }
       
       scope.tagValuesUpdated = function()
       {

          scope.updated();
       };

       scope.sortDirs = [
          {id: 'asc', desc: 'Ascending'},
          {id: 'desc', desc: 'Descending'}
       ];
       

       if( scope.query.tagValues.length )
       {
          $http.get('/api/tagValues', {
             params: {
                'id': scope.query.tagValues
             }
          }).then(function(results) {
             results.data._embedded.tagValues.forEach(function(tag) {
                if( tag.logId == scope.selectedLog.id)
                {
                   scope.selectedTagValues.push(tag._links.self.href);
                   scope.selectedTagValueObjects.push(tag);
                }
                else
                {
                   scope.query.tagValues.splice(scope.query.tagValues.indexOf(tag.id), 1);
                }
                scope.updateSearch();
             })
          });
       }
       
       userService.getHistoricalLogUsersByLogId(scope.selectedLog.id).subscribe(logBookUsers => {
		  scope.users = logBookUsers;
		  
          let createdOk, updatedOk = false;
		  
          scope.users.forEach(user => {
             if(scope.query.createdBy == user.id )
                createdOk = true;
             if( scope.query.updatedBy == user.id )
                updatedOk = true;
          });
          
          if( scope.query.createdBy && !createdOk )
          {
             delete scope.query.createdBy;
             scope.updated();
          }
          
          if( scope.query.updatedBy && !updatedOk )
          {
             delete scope.query.updatedBy;
             scope.updated();
          }
       });
             
       reminderService.getStatuses().toPromise().then(function(response) {
          scope.statuses = response;
       });
       
       scope.updated = function()
       {
          scope.query.log = scope.selectedLog.id;
          scope.updateSearch();
          $timeout(function() {
             scope.onUpdate && scope.onUpdate();
          });
       };

       scope.updateSearch = function() {
          $location.search('query', 
                JSON.stringify(scope.query,
                function(key, value) {
                   if( value instanceof Array
                      && value.length == 0 )
                      return undefined;
                   return value;
          })).replace();
       };
       
       scope.$watchGroup(['query.page', 'query.size'], function() {
          scope.updateSearch();
       })
       
       scope.setSimpleThruDate = function()
       {
          scope.query.thruDate = new Date(scope.query.fromDate);
          scope.query.thruDate.setDate(scope.query.thruDate.getDate() + 1);
       }
       
       scope.queryFormats = [
          {id: "S", description: "Simple"},
          {id: "A", description: "Advanced"}
       ];
       scope.queryFormat = 
          $location.search()['query-format']
              ? $location.search()['query-format']
              : 'S';

       scope.resultFormats = [
           {id: "B", description: "Brief"},
           {id: "D", description: "Detailed"}
        ];
        scope.resultFormat = 
           $location.search()['result-format']
              ? $location.search()['result-format']
              : 'B';


        scope.ensureFromDate = function()
        {
          if( !("fromDate" in scope.query))
          {
             var today = new Date();
             today.setHours(0,0,0,0);
             scope.query.fromDate = today;
             if( scope.simple )
                scope.setSimpleThruDate();
          }
        };
        
       scope.queryFormatChanged = function() {
          scope.simple = scope.queryFormat === "S";
          $location.search('query-format', scope.queryFormat).replace();
          scope.query.page=0;

          if( scope.simple )
          {
             if( !scope.query.fromDate )
                delete scope.query.fromDate;
             scope.ensureFromDate();
             scope.query.fromDate = new Date(scope.query.fromDate);
             scope.query.fromDate.setHours(0,0,0,0);
             scope.setSimpleThruDate();
             
             Object.keys(scope.query).forEach(function(key) {
                var allowed = ['fromDate','thruDate','turnover','page', 'size', 'log', 'report'];
                if(allowed.indexOf(key) < 0 )
                   delete scope.query[key];
             });
             
             scope.query.tagValues = [];
             scope.setDefaultSort();
             scope.updated();
          }
       };
       
       scope.toggleStatus = function(status)
       {
          if( !("status" in scope.query) )
             scope.query.status = [];
          
          var idx = scope.query.status.indexOf(status.id);

          if (idx > -1) {
            scope.query.status.splice(idx, 1);
          }
          else {
            scope.query.status.push(status.id);
          }
          scope.updated();
       }

       scope.setDefaultSort = function()
       {
          if( scope.defaultSortKey && scope.selectedLog.logConfigs[scope.defaultSortKey])
          {
             var sorts = JSON.parse(scope.selectedLog.logConfigs[scope.defaultSortKey]);
             scope.sort = [sorts[0].sort || scope.validSorts[0].id, sorts[1].sort || scope.validSorts[0].id];
             scope.sortDir = [sorts[0].dir || scope.sortDirs[0].id, sorts[1].dir || scope.sortDirs[0].id];
          }
          else
          {
             scope.sort = [scope.validSorts[0].id, scope.validSorts[0].id];
             scope.sortDir = [scope.sortDirs[0].id, scope.sortDirs[0].id];
          }
          scope.updateSort();
       }
       
       scope.updateSort = function()
       {
          scope.query.sort = [];
          scope.query.sort[0] = scope.sort[0] + ',' + scope.sortDir[0];
          scope.query.sort[1] = scope.sort[1] + ',' + scope.sortDir[1];
       }

       scope.resultFormatChanged = function() { 
		   $location.search('result-format', scope.resultFormat).replace();
		   
		   scope.onResultFormatChanged && scope.onResultFormatChanged(scope.resultFormat);
       };
       
       scope.queryFormatChanged();
       if (!scope.simple) scope.updated();
    }
  }
}]);
